import { ElementType } from 'react';
import { Grid, styled, Typography } from '@material-ui/core';

import Colors from 'styles/colors';

export const Wrapper = styled(Grid)({
  position: 'relative',
});
